/**
 * Created by Mark on 17/04/2017.
 */




import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHeader from '../components/card-header.js';
import LessonPlanService from '../services/songs-and-stories-services.js';
import LessonPlanStore from '../store/songa-and-stories-store.js';
import { FormattedMessage } from 'react-intl';
import CDNImage from '../components/media/image.js';
import fuzzysearch from 'fuzzysearch';
import InternationalizationStore from '../store/internationalization-store.js';
import {Col , Row , Button} from 'react-bootstrap';
import LanguageSelector from "../components/inputs/language-selector.js";
import Select from  'react-select';

export default class LessonPlansComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            plans:[],
            allPlans:[],
            language:{value: 'en' ,label: <FormattedMessage id={ "ui-"+'45' } defaultMessage={ 'language' }/> , options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            type: {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}
        }
    }


    componentDidMount() {
        LessonPlanService.getAll()
    }

    componentWillMount(){
        LessonPlanStore.on("CHANGE" , () => {
            this.setState({
                plans:LessonPlanStore.getAll(),
                allPlans:LessonPlanStore.getAll()
            });
        });
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.handelUserSearch(this.search.value) }.bind(this), 500)
        });
    }

    handelUserSearch(searchTerm){

        var searchTerm = searchTerm.trim();

        if(searchTerm.length <= 3)
        {
            this.setState({plans:this.state.allPlans});
            return
        }


        var searchedRows = [];

        for(var idx = 0; idx < this.state.allPlans.length; idx++)
        {
            if(!this.state.allPlans[idx]) continue;

            //var title   = InternationalizationStore.getTranslation('ui-'+this.state.allPlans[idx].name);
            //var summary   = InternationalizationStore.getTranslation('ui-'+this.state.allPlans[idx].summary_translation_uid);

            if(fuzzysearch(String(searchTerm).toLowerCase() , String(this.state.allPlans[idx].name).toLowerCase()))
            {
                searchedRows.push(this.state.allPlans[idx]);
            }
            //else if(fuzzysearch(String(searchTerm).toLowerCase() , String(summary).toLowerCase()))
            //{
               // searchedRows.push(this.state.allPlans[idx]);
            //}

        }

        this.setState({plans:searchedRows})
    }

    lessonPlanThumb(){

        var plans = [];

        for(var idx = 0 ; idx < this.state.plans.length; idx++)
        {
            let unitID = this.state.plans[idx].unit_uid;
            let code = this.state.plans[idx].language_code;
            let type = String(this.state.plans[idx].type).toLowerCase();

            let path = "img/school.png";

            if(Number(unitID) <= 6)
            {
                path = "img/farm.png";
            }

            if(Number(unitID) <= 12 && Number(unitID) > 6)
            {
                path = "img/school.png";
            }

            if(Number(unitID) <= 18 && Number(unitID) > 12)
            {
                path = "img/beach.png";
            }



            if(type === "story")
            {
                path = "img/Generic Book.png";
            }

            plans.push(<div className="col-sm-6 col-md-3">
                <a href={"#/"+type+"/"+unitID+"/"+code} className="thumbnail">
                    <div className="placeholder">

                        <img style={{maxHeight:150 , maxWidth:150 , width:"auto"}}src ={path}/>
                    </div>
                    <div className="caption">
                        <h4 className="titletextOverflow"><img className="avatar-img small" src={"img/flags/"+this.state.plans[idx].ietf+".png"} alt=""/>  <FormattedMessage id={ "ui-142" } defaultMessage={ "No Results Found" }/> : {unitID}</h4>
                        <p style={{minHeight:"30px" , maxHeight:"30px"}}className="text-justify textOverflow" >{this.state.plans[idx].name}</p>
                        <div className="m-b-20">
                            <a  className="palette-Branding secondary bg btn btn-block waves-effect" role="button">
                                <span className="palette-White text">
                                    <FormattedMessage id={ "ui-596" } defaultMessage={ "No Results Found" }/>
                                </span>
                            </a>
                        </div>
                    </div>
                </a>
            </div>)
        }

        return plans;
    }

    filterData(language , type){

        let media = [];
        for(var idx = 0 ; idx < this.state.allPlans.length; idx++)
        {
            if(language.value == this.state.allPlans[idx].ietf)
            {
                if(type.value == "both")
                {
                    media.push(this.state.allPlans[idx])
                }
                else
                {
                    if(type.value == "story" &&  String(this.state.allPlans[idx].type).toLowerCase() == "story")
                    {
                        media.push(this.state.allPlans[idx])
                    }

                    if(type.value == "song" &&  String(this.state.allPlans[idx].type).toLowerCase() == "song")
                    {
                        media.push(this.state.allPlans[idx])
                    }
                }

            }

        }

        this.setState({plans:media});

    };

    handelTypeSelection(type){

        this.filterData(this.state.language , type)
        this.setState({type:type});
    }

    handelLanguageSections(language){

        console.log(language)
        this.filterData(language , this.state.type)

        if(language.options.length == 1)
        {
            this.setState({language:language , type:language.options[0]});
            this.filterData(language , language.options[0])
        }
        else{
            this.setState({language:language});
            this.filterData(language , this.state.type)
        }

    }

    render(){


        const languages =[
            {value: 'af' ,label: <FormattedMessage id={ "ui-"+'64' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'ar' ,label: <FormattedMessage id={ "ui-"+'50' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'cn' ,label: <FormattedMessage id={ "ui-"+'54' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'cy' ,label: <FormattedMessage id={ "ui-"+'55' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'de' ,label: <FormattedMessage id={ "ui-"+'48' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'en' ,label: <FormattedMessage id={ "ui-"+'45' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'en-us' ,label: <FormattedMessage id={ "ui-"+'57' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'es' ,label: <FormattedMessage id={ "ui-"+'47' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'es-MX' ,label: <FormattedMessage id={ "ui-"+'58' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'fr' ,label: <FormattedMessage id={ "ui-"+'46' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'gd' ,label: <FormattedMessage id={ "ui-"+'56' } defaultMessage={ 'language' }/>, options:[{value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'ht' ,label: <FormattedMessage id={ "ui-"+'65' } defaultMessage={ 'language' }/>, options:[ {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'hz' ,label: <FormattedMessage id={ "ui-"+'53' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'it' ,label: <FormattedMessage id={ "ui-"+'49' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'ja' ,label: <FormattedMessage id={ "ui-"+'51' } defaultMessage={ 'language' }/>, options:[{value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'mi' ,label: <FormattedMessage id={ "ui-"+'62' } defaultMessage={ 'language' }/>, options:[{value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>}]},
        ]






        const options = [
            {value:"story" , label:<FormattedMessage id={ "ui-2015" } defaultMessage={ "Stories" }/>},
            {value:"song" ,  label:<FormattedMessage id={ "ui-2014" } defaultMessage={ "Songs" }/>},
        ];

        return (<Layout>
                   <Card>
                       <CardHeader>
                           <h2><FormattedMessage id={ "ui-101" } defaultMessage={ "No Results Found" }/></h2>
                       </CardHeader>
                       <CardBody>
                               <div className="row">
                                   <Col md={3}>
                                       <Select
                                           value={this.state.language}
                                           onChange={this.handelLanguageSections.bind(this)}
                                           options={languages}
                                           />
                                   </Col>
                                   <Col md={3}>
                                       <Select
                                           value={this.state.type}
                                               onChange={this.handelTypeSelection.bind(this)}
                                               options={this.state.language.options}
                                               noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>} />
                                   </Col>
                               </div>
                               <div className="row">
                                    {this.lessonPlanThumb()}
                               </div>
                           </CardBody>
                   </Card>
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/songs-stories.js